import React, { Component, useEffect, useState } from 'react';
import BlockList from './lists/blocklist.jsx';
import EndpointList from './lists/endpointlist.jsx'
import * as d3 from "d3";

function Lists (props) {

    const updateURL = props.updateURL

    function highlightQuery (string, search) {
        if (search === undefined || search === '') return string
        else {
          const capitalized = search[0].toUpperCase() + search.slice(1).toLowerCase()
          const underscore = search.toLowerCase().replaceAll(' ', '_')
          const cases = [search.toUpperCase(), search.toLowerCase(), capitalized, underscore]
          cases.forEach(el => string = !string.includes('<span class="matchingQuery">') ? string.replace(el, '<span class="matchingQuery">' + el + '</span>') : string)
          return string
        }
    }

    updateURL('lists', props.endpoints.code)

    useEffect(()=> {
    })


    return (
        <div id="lists">
            <BlockList 
                data={props.blocks}
                contentHeight={props.contentHeight}
                search={props.search}
                setSearch={props.setSearch}
                endpoints={props.endpoints}
                setEndpoints={props.setEndpoints}
                highlightQuery={highlightQuery}
            />
            <EndpointList 
                data={props.endpoints}
                setData={props.setEndpoints}
                color={props.color}
                format={props.format}
                retrieve={props.retrieve}
                contentHeight={props.contentHeight}
                search={props.search}
                setSearch={props.setSearch}
                setView={props.setView}
                setNetwork={props.setNetwork}
                highlightQuery={highlightQuery}
                heatmap={props.heatmap}
                setHeatmap={props.setHeatmap}
                updateHeatmap={props.updateHeatmap}
                networkRoots={props.networkRoots}
            />
        </div>
    )
}

export default Lists;